import moment from 'moment'

function formatDateFactory(date) {
    function formatByDateInstance(separator = '/') {
        let dateInstance = new Date(date)

        return [
            dateInstance.getDate(),
            dateInstance.getMonth() + 1,
            dateInstance.getFullYear()
        ].join(separator)
    }

    function formatByMoment(format = 'YYYY-MM-DD', separator = '/') {
        return moment(
            date,
            format
        ).format(`DD${separator}MM${separator}YYYY`)
    }

    return { formatByDateInstance, formatByMoment }

}

const Utils = {
    datetimeConverter(results) {
        return results.map(element => {
            if (element.datetime_created) {
                element.datetime_created = formatDateFactory(element.datetime_created).formatByDateInstance()
            }

            if (element.datetime_updated) {
                element.datetime_updated = formatDateFactory(element.datetime_updated).formatByDateInstance()
            }

            if (element.datetime_first_purchase) {
                element.datetime_first_purchase = formatDateFactory(element.datetime_first_purchase).formatByMoment()
            }

            if (element.datetime_last_purchase) {
                element.datetime_last_purchase = formatDateFactory(element.datetime_last_purchase).formatByMoment()
            }

            if (element.datetime_telegram_activation) {
                element.datetime_telegram_activation = formatDateFactory(element.datetime_telegram_activation).formatByDateInstance()
            }

            return element
        })
    },

    formatNumber(number, type, shorten) {
        if (isNaN(Number(number))) return number
        number = Number(number)

        if (shorten) {
            let units = ['k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'],
                decimal

            for (let i = units.length - 1; i >= 0; i--) {
                decimal = 1000 ** (i + 1)
                if (Math.abs(number) >= decimal) {
                    number = (number / decimal).toFixed(2) + units[i]
                    break
                }
            }
        }

        if (type == 'int')
            return number.toLocaleString(undefined, {
                maximumFractionDigits: 0
            })
        else if (type == 'float')
            return number.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })

        return number
    },

    roundNumber(num, decimals) {
        let base = decimals ? 10 ** decimals : 100
        return Math.round(num * base) / base
    },

    deepCopy(obj) {
        return JSON.parse(JSON.stringify(obj))
    },

    historicSalesSeriesConverter(results, aggregation_type) {
        if (aggregation_type === 'month') {
            return results.map(element => [
                Date.UTC(Number(element.year), Number(element.interval) - 1),
                Number(element.quantity)
            ])
        } else {
            return results.map(element => {
                const date = moment(element.interval, 'YYYY-MM-DD').toDate()
                const dateUTC = Date.UTC(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate()
                )
                return [dateUTC, Number(element.quantity)]
            })
        }
    },

    historicStocksSeriesConverter(results, aggregation_type) {
        if (aggregation_type === 'month') {
            return results.map(element => [
                Date.UTC(Number(element.year), Number(element.interval) - 1),
                Number(element.balance_total_cost)
            ])
        } else {
            return results.map(element => {
                const date = moment(element.interval, 'YYYY-MM-DD').toDate()
                const dateUTC = Date.UTC(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate()
                )
                return [dateUTC, Number(element.balance_total_cost)]
            })
        }
    },

    demandsSeriesConverter(results) {
        return results.map(element => [
            element.demand.map(item => {
                const date = moment()
                    .day('Sunday')
                    .year(Number(item.year))
                    .week(item.interval + 1) // plus one to fix moment week
                    .toDate()
                const dateUTC = Date.UTC(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate()
                )
                return [
                    // Date.UTC(Number(item.year), Number(item.interval) - 1),
                    dateUTC,
                    Number(item.quantity),
                    Number(element.demand_id),
                    Boolean(element.active)
                ]
            })
        ])
    },

    formatByMoment(date, separator = '/', format = 'YYYY-MM-DD') {
        return formatDateFactory(date).formatByMoment(format, separator)
    },

    toggle(id, array) {
        const index = array.indexOf(id)
        if (index > -1) {
            array.splice(index, 1)
        } else {
            array.push(id)
        }
    },

    getQueryParams(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }

        return queryParams
    }
}

export default Utils
export { Utils }
